export class ComponentInfoVo {
    constructor(

        public componentName?: string,

        public startDt?: string,

        public estimatedCompletionDt?: string,

        public authorizedHours?: string,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/component-info-co-vo.ts